import React from "react";
import i18next from "i18next";
import _ from "lodash";
import Constants from "../config/Constants";
import AppConfig from "../config/AppConfig";
import { v4 as uuid } from "uuid";
import i18n from 'i18next'; // Fix: Import i18n to resolve 'I18n' is not defined
import Cookies from 'universal-cookie';

import UIDs from "../UIDs";
import dayjs from "./dayjs";

const countries = require("i18n-iso-countries");
// If you use the package in a browser environment, you have to register the languages you want to use to minimize the file size.
// countries.registerLocale(require("i18n-iso-countries/langs/zh.json"));
// countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
// countries.registerLocale(require("i18n-iso-countries/langs/th.json"));
// countries.registerLocale(require("i18n-iso-countries/langs/ko.json"));
// countries.registerLocale(require("i18n-iso-countries/langs/ja.json"));
// countries.registerLocale(require("i18n-iso-countries/langs/pt.json"));
// countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
// countries.registerLocale(require("i18n-iso-countries/langs/ru.json"));

// const pinyinSplit = require("pinyin-split");
function convertSnakeCaseKeysToCamelCase(obj) {
    //if not object or array we just return
    if (!_.isObject(obj) && !_.isArray(obj)) {
        return obj;
    }
    let camelCaseObject;
    //if object we return a object, if array we return array
    if (_.isPlainObject(obj)) {
        camelCaseObject = {};
    } else if (_.isArray(obj)) {
        camelCaseObject = [];
    }
    _.forEach(obj, function (value, key) {
        if (_.isPlainObject(value) || _.isArray(value)) {
            // checks that a value is a plain object or an array - for recursive key conversion
            value = convertSnakeCaseKeysToCamelCase(value); // recursively update keys of any values that are also objects
        }
        camelCaseObject[_.camelCase(key)] = value;
    });
    return camelCaseObject;
}

function convertCamelCaseKeysToSnakeCase(obj) {
    //if not object or array we just return
    if (!_.isObject(obj) && !_.isArray(obj)) {
        return obj;
    }
    let snakeCaseObject = {};
    //if object we return a object, if array we return array
    if (_.isPlainObject(obj)) {
        snakeCaseObject = {};
    } else if (_.isArray(obj)) {
        snakeCaseObject = [];
    }
    _.forEach(obj, function (value, key) {
        if (_.isPlainObject(value) || _.isArray(value)) {
            // checks that a value is a plain object or an array - for recursive key conversion
            value = convertCamelCaseKeysToSnakeCase(value); // recursively update keys of any values that are also objects
        }
        snakeCaseObject[_.snakeCase(key)] = value;
    });
    return snakeCaseObject;
}

function convertCamelCaseKeysToUpperSnakeCase(obj) {
    //if not object or array we just return
    if (!_.isObject(obj) && !_.isArray(obj)) {
        return obj;
    }
    let snakeCaseObject = {};
    //if object we return a object, if array we return array
    if (_.isPlainObject(obj)) {
        snakeCaseObject = {};
    } else if (_.isArray(obj)) {
        snakeCaseObject = [];
    }
    _.forEach(obj, function (value, key) {
        if (_.isPlainObject(value) || _.isArray(value)) {
            // checks that a value is a plain object or an array - for recursive key conversion
            value = convertCamelCaseKeysToUpperSnakeCase(value); // recursively update keys of any values that are also objects
        }
        snakeCaseObject[_.toUpper(_.snakeCase(key))] = value;
    });
    return snakeCaseObject;
}

function getCurrentLocale() {
    return i18n.language;
}

function isCNCulture() {
    return getCurrentLocale().includes("zh");
}


function decodeURL(url) {
    try {
        return decodeURIComponent(url);
    } catch (e) {
        return url;
    }
}

function subString(fullString, startNdx, length, addDots) {
    if (fullString.length > startNdx + length) {
        return fullString.substring(startNdx, length) + (addDots ? "..." : "");
    } else {
        return fullString.substring(startNdx);
    }
}

//match ="http://
const httpRegex1 = new RegExp('="http://', "g");
//match ='http://
const httpRegex2 = new RegExp("='http://", "g");
//if html have url like http://www.... can not be load in https env.
//so replace all to // to make it auto fill
function replaceHttpToFitHttpsInHtml(htmlStr) {
    if (!htmlStr) {
        return "";
    }

    return htmlStr.replace(httpRegex1, '="https://').replace(httpRegex2, "='https://");
}

const httpRegex3 = new RegExp("^http://", "g");

//replace http url to https url
function replaceURLToHttps(htmlStr) {
    if (!htmlStr) {
        return "";
    }

    return htmlStr.replace(httpRegex3, "https://");
}

function formatToHtmlString(content) {
    return `<html><head><style>*{box-sizing: border-box;}p{margin-top: 4px;margin-bottom: 4px}</style></head><body><div style="font-size:12px;padding: 4px;">${content}</div></body></html>`;
}

const formatString = (str, ...args) => {
    return str.replace(/{(\d+)}/g, (match, number) => {
        return typeof args[number] !== "undefined" ? args[number] : match;
    });
};

function getENNumSeqSuffix(index) {
    let pNum = index;
    if (!_.isNumber(index)) {
        pNum = _.toNumber(index);
        if (pNum <= 0 || isNaN(pNum)) {
            return "";
        }
    }
    switch (pNum) {
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
        default:
            return "th";
    }
}

function generateUUID() {
    const id = uuid();
    return _.replace(id, /-/gm, "");
}

function convertToFileServerPath(serverPath) {
    if (!serverPath || serverPath.length < 2) return "";
    else if (serverPath.indexOf("~/") === 0) return fileServerPath() + serverPath.substring(2);
    else return serverPath;
}

function replaceHtmlVirtualPath(html) {
    if (!html) {
        return html;
    }
    return html.split("${YIDU_FILE_SERVER}~/").join(fileServerPath());
}

const fileServerPath = () => {
    if (AppConfig.FILE_SERVER) {
        if (AppConfig.FILE_SERVER.endsWith("/")) {
            return AppConfig.FILE_SERVER;
        }
        return AppConfig.FILE_SERVER + "/";
    } else return AppConfig.APP_SERVICE_BASE + "/";
};

const isGuest = (memberId) => {
    return _.toLower(memberId) === _.toLower(Constants.USER_GUEST);
};

const isLoggedIn = (memberId) => {
    if (!isGuest(memberId)) {
        return !_.isEmpty(memberId) && hasLoggedInCookie();
    }
    return false;
};

const hasLoggedInCookie = () => {
    if (window.IS_ELECTRON){
        return true;// for electron, we always consider it logged in since we do not need to check cookie
    }
    const cookies = new Cookies();
    return cookies.get('ApiRefreshTokenForSPA') && cookies.get('ApiTokenForSPA');
};


const isNumeric = (n) => {
    return !isNaN(parseFloat(n)) && isFinite(n);
};

const isNullOrEmpty = (s) => {
    return _.isNull(s) || _.isEmpty(s);
};

const isNullOrUndefined = (o) => {
    return _.isNull(o) || _.isUndefined(o);
};

const isCharacter = (str) => {
    if (Object.prototype.toString.call(str) !== "[object String]") {
        return false;
    }
    if (str && str.length !== 1) {
        return false;
    }
    const testCases = [
        ["\u4E00", "\u9FEF"], //基本汉字&基本汉字补充
        ["\u3400", "\u4DB5"], //扩展A
        ["\u{20000}", "\u{2A6D6}"], //扩展B
        ["\u{2A700}", "\u{2B734}"], //扩展C
        ["\u{2B740}", "\u{2B81D}"], //扩展D
        ["\u{2B820}", "\u{2CEA1}"], //扩展E
        ["\u{2CEB0}", "\u{2EBE0}"], //扩展F
    ];
    for (const t of testCases) {
        if (t[0] <= str && str <= t[1]) {
            return true;
        }
    }
    return false;
};

const randomizeArray = (arr) => {
    const length = arr.length;
    let arr1 = [];
    for (var i = 0; i < length; i++) {
        arr1[i] = i;
    } //建立数组下标数组
    let arr2 = [];
    for (let i = 0; i < length; i++) {
        arr2[i] = arr1.splice(Math.floor(Math.random() * arr1.length), 1);
    } //将数组下标随机打乱
    let arr3 = [];
    for (let i = 0; i < length; i++) {
        arr3[i] = arr[arr2[i]];
    } //将数组按打乱后的下标输出
    return arr3;
};


const createArrayWithNumbers = (length) => {
    return Array.from({ length }, (_, k) => k);
};

const isChinese = (val) => {
    return /^[\u4E00-\u9FA5]+$/.test(val);
};
const isEnglish = (val) => {
    return /^[a-zA-Z0-9'\s-]+$/.test(val);
};

const isPunctuation = (val) => {
    return "·￥。？！，、；：“”…（）《》『』【】—．〈〉〔〕「」‘’–.?!,;:\"()-#$%&'*+/<=>@[\\]^_`{|}~ ".indexOf(val) > -1;
};

/**
 * 只比较中文和字母数字
 * @param char
 * @returns {boolean}
 */
const IsNoNeedCompareChar = (char) => {
    const regex = /[A-Za-z0-9]/;
    if (regex.test(char)) {
        return false;
    }

    if (isPunctuation(char)) {
        return true;
    }
    return !isChineseCharacters(char);
};

const containSpecialPunctuations = (val) => {
    const specialPunctions = ".?()$*+[]^_|";
    return val && val.split("").findIndex((e) => specialPunctions.indexOf(e) > -1) > -1;
};

const sentencePunctuations = ["!", "?", ";", "。", "！", "？", "；", "…"];


/**
 * split into words with punctuations
 * ·￥。？！，、；：“”（）…《》『』【】—．〈〉〔〕「」‘’–
 * . ? ! , ; : " ( ) - #$%&'*+/<=>@[\\]^_`{|}~
 * @param {string} val
 * @return {string[]}
 */
const getWords = (val) => {
    return val
        .split(
            /[\u00b7\uffe5\u3002\uff1f\uff01\uff0c\u3001\uff1b\uff1a\u201c\u201d\uff08\uff09\u2026\u300a\u300b\u300e\u300f\u3010\u3011\u2014\uff0e\u3008\u3009\u3014\u3015\u300c\u300d\u2018\u2019\u2013\u0020-\u002f\u003a-\u0040\u005b-\u0060\u007b-\u007e\n\t\v\f\r]/g
        )
        .filter((s) => s);
};


const getLocale = (lngCode) => {
    // for (var i = 0; i < Constants.SUPPORTED_LANGUAGES.length; i++) {
    //     if (Constants.SUPPORTED_LANGUAGES[i].code === lngCode) {
    //         return Constants.SUPPORTED_LANGUAGES[i].culture;
    //     }
    // }

    return "en-US";
};

// function countryCompareZH(a, b) {
//     return pinyin.compare(a, b);
// }

const getCountries = () => {
    let allCountries = countries.getNames(i18next.language, { select: "official" });
    allCountries = _.omit(allCountries, ["AX"]); //AIC-9-450 暂时去掉Åland Islands的选项

    let allOrderedCountries;
    // sort by alphabet
    if (i18next.language === "zh") {
        // 中文按拼音排序
        //allOrderedCountries = Object.values(allCountries).sort(countryCompareZH);
    } else {
        // 其它语言按字母排序
        allOrderedCountries = Object.values(allCountries).sort();
    }

    //由于排序之后，没有了国家代码的缩写，重新根据序排后的值，在设置一下缩写
    let newOrderedCountries = {};
    allOrderedCountries.forEach((item, index) => {
        let countryCode = countries.getAlpha2Code(item, i18next.language);
        newOrderedCountries[countryCode] = item;
    });

    return newOrderedCountries;
    //return allOrderedCountries;
};

const getCountryName = (countryCode) => {
    return countries.getName(countryCode, i18next.language, { select: "official" });
};

const getLastFileName = (path) => {
    return path ? path.substring(path.lastIndexOf("/") + 1, path.length) : "";
};

function numberWithCommas(x) {
    return x && x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/**
 * Convert UTC To Local Time
 *
 * @param {*} date
 * @return {*}
 */
const convertToLocalTime = (date) => {
    if (!date) return date;

    const timeZone = dayjs.tz.guess(true);
    const localDate = dayjs.utc(dayjs(date).format("YYYY-MM-DDTHH:mm:ss.SSS")).tz(timeZone).toDate();
    return new Date(localDate);
};

//转成本地时间 进行格式化
const convertToLocalString = (date) => {
    const localDate = convertToLocalTime(date);
    return dayjs(localDate).format("YYYY-MM-DD HH:mm:ss");
};

/**
 * Convert Local Time To UTC
 * @param {*} date
 * @returns
 */
const convertToUtcTime = (date) => {
    if (!date) return date;

    const y = date.getUTCFullYear();
    const m = date.getUTCMonth();
    const d = date.getUTCDate();
    const h = date.getUTCHours();
    const M = date.getUTCMinutes();
    const s = date.getUTCSeconds();
    const utcDate = new Date(y, m, d, h, M, s);

    return utcDate;
};

const formatToUtcTime = (dateString) => {
    // const pattern = /^(\d{4}).(\d{1,2}).(\d{1,2}).? (\d{1,2}).(\d{1,2}).?(\d{1,2})?.?$/;
    // if (!pattern.test(dateString)) {
    // 	return dateString;
    // }

    // const formatDate = new Date(dateString.replace(pattern, '$1/$2/$3 $4:$5:$6'));
    if (!dayjs(dateString).isValid()) return dateString;
    return dayjs.utc(dateString).format("YYYY/MM/DD HH:mm:ss");
};

const addDays = (date, days) => {
    var result = new Date(date);
    result.setDate(date.getDate() + days);
    return result;
};

//
// beijing: 8 (UTC +8), seattle: -8 (UTC -8)
//
function getTimeZone() {
    return 0 - new Date().getTimezoneOffset() / 60;
}

function isNumberWithPunctuations(text) {
    let ret = getWords(text).every((item) => isNumeric(Number(item)));
    return ret;
}

function splitByDigit(text, d, seperator = "") {
    if (!text || !isNumeric(d) || d === 0) return text;

    let str = "";
    for (let i = 1; i <= text.length; i++) {
        if (i % d === 1 && parseInt(i / d) === parseInt(text.length / d)) {
            str += text.substr(i - 1);
            break;
        }
        if (i % d === 0) {
            str += text.substr((parseInt(i / d) - 1) * d, d) + seperator;
        }
    }
    return str.trim();
}

function displayPhone(phone) {
    let codes = phone ? phone.split("-") : [];
    let phoneNumber = codes.length === 3 ? `${codes[0]}-${codes[2]}` : phone;
    return phoneNumber;
}

function buildFilePathInUnits(serverPath, useLocalFilePath) {
    // if (useLocalFilePath) {
    //     let localPath = "";
    //     if (!serverPath || serverPath.length < 2) {
    //         localPath = DocumentDirectoryPath + Constants.LOCAL_FILE_STORAGE.ROOT_PATH;
    //     } else if (serverPath.indexOf("~/") === 0) {
    //         localPath = DocumentDirectoryPath + Constants.LOCAL_FILE_STORAGE.ROOT_PATH + serverPath.replace(Constants.FILE_STORAGE.ROOT_PATH, "/");
    //     } else {
    //         localPath = serverPath;
    //     }
    //     return `file://${localPath}`;
    // } else {
    if (!serverPath || serverPath.length < 2) {
        return fileServerPath();
    } else if (serverPath.indexOf("~/") === 0) {
        return fileServerPath() + serverPath.substring(2);
    } else {
        return serverPath;
    }
    // }
}

function stripDeletedEmail(email) {
    if (email.startsWith("_DELETED_")) {
        let pos = email.indexOf("_", 9);
        if (pos >= 0) {
            return email.substring(pos + 1);
        }
    }
    return email;
}

function getLanguageCodes() {
    let codes = [];

    for (var i = 0; i < Constants.SUPPORTED_LANGUAGES.length; i++) {
        codes.push(Constants.SUPPORTED_LANGUAGES[i].code);
    }

    return codes;
}

function existsSepcialContent(val) {
    var nameReg = /[^\a-\z\A-\Z0-9\u4E00-\u9FA5\.\,\?\ \_\<\>\。\，\[\]\*\&\^\%\#\@\$\￥\……\(\)\、\-\——\=\;\@\！\!\+\$]/g;
    return nameReg.test(val);
}

function getImageWidthHeightWithPath(imgWidth, imgHeight, maxImgWidth) {
    let scale = 1;
    if (imgWidth > maxImgWidth) {
        scale = maxImgWidth / imgWidth;
        imgWidth = parseInt(imgWidth * scale);
    }

    imgHeight = parseInt(imgHeight * scale);

    return { imgWidth, imgHeight };
}

function convertToAbsoluteUrl(serverPath) {
    // if (!serverPath || serverPath.length < 2) {
    //     return DocumentDirectoryPath;
    // } else if (serverPath.indexOf("~/") === 0) {
    //     return DocumentDirectoryPath + serverPath.substring(1);
    // } else {
    //     return serverPath;
    // }
    if (serverPath) {
        // webApp查看历史作业时，打开页面播放器的默认文件是空的
        serverPath = serverPath.replace("ü", "v");
        if (!serverPath || serverPath.length < 2) {
            return fileServerPath();
        } else if (serverPath.indexOf("~/") === 0) {
            return fileServerPath() + serverPath.substring(2);
        } else {
            return serverPath;
        }
    }
    return serverPath;
}


const getAvatarStr = (userName) => {
    let avatarStr = "";
    if (userName) {
        if (userName.indexOf(" ") > 0) {
            let nameArray = _.split(userName, " ", 2);
            avatarStr = nameArray[0].substr(0, 1) + nameArray[1].substr(0, 1);
        } else {
            avatarStr = userName.substr(0, 1);
        }
    }
    return avatarStr.toUpperCase();
};

// e.g., [[],[],...]
const createTwoDimensionArray = (length) => {
    return Array(length)
        .fill(null)
        .map(() => []);
};

/**
 * get the number order string
 *
 * @param {int} i
 * @return {string}
 */
const getNumberStr = (i) => {
    let lan = i18next.language ? i18next.language : "en";
    if (!isNumeric(i) || i < 1) return "";
    if (lan !== "en") return i;

    switch (i) {
        case 1:
            return "1st";
        case 2:
            return "2nd";
        case 3:
            return "3rd";
        default:
            return i + "th";
    }
};
function buildPathSegments(str) {
    if (isNullOrEmpty(str)) {
        return ["000", "000"];
    }

    var chunks = str.match(/.{1,3}/g);
    if (chunks.length < 2) {
        chunks = ["000", "000"];
    }

    return chunks;
}

const isSubjective = (unitType) => {
    return unitType && unitType.startsWith("PS");
};

const removeSepcialUnicode = (val) => {
    if (_.isObjectLike(val)) {
        let returnObj = _.isArray(val) ? [] : {};
        _.forIn(val, (v, k) => {
            returnObj[k] = removeSepcialUnicode(v);
        });
        return returnObj;
    } else if (_.isString(val)) {
        // eslint-disable-next-line no-control-regex
        return val.replace(/[\u0000-\u0009|\u000B-\u000C|\u000E-\u001F|\u007F-\u00A0]/gi, ""); //跳过换行\u000a  \u000d
        //return val.replace(/[\u0000-\u001F|\u007F-\u00A0]/gi, "");
    } else {
        return val;
    }
};

function getWeekDays(daysInWeek) {
    let selectedDays = [];
    let numPerWeek = 0;
    for (let index = 0; index < 7; index++) {
        if (daysInWeek & (2 ** index)) {
            selectedDays.push(index);
            numPerWeek += 1;
        }
    }
    return { selectedDays, numPerWeek };
}

//手机端页面设置的大小，宽度要随着mobile/css/mobile.scss中mobileRoot的宽度改变
function getContainerSize() {
    return {
        width: window.innerWidth > 960 ? 960 : window.innerWidth,
        height: document.documentElement.clientHeight < 600 ? 600 : document.documentElement.clientHeight, //window.innerHeight
    };
}

function clearCache(successCallback, failCallback) {
    if (successCallback) {
        successCallback();
    }
}

function isChineseCharacters(s) {
    return /[\u3000-\u303F\u3400-\u4DBF\u4E00-\u9FFF]/.test(s);
}

function formatTimeDuration(secs) {
    let hour = parseInt(secs / 3600);
    secs -= hour * 3600;
    let minute = parseInt(secs / 60);
    secs -= minute * 60;
    var stayTime = null;
    return ("0" + hour).slice(-2) + ":" + ("0" + minute).slice(-2) + ":" + ("0" + secs).slice(-2);
}

const extractAllValuesIntoArray = (obj) => {
    const tmpList = [];
    _.each(obj, function (value, key) {
        if (_.isString(value)) {
            tmpList.push(value);
        } else {
            tmpList.push(...extractAllValuesIntoArray(value));
        }
    });
    return tmpList;
};

/**
 * 计算排列组合
 * https://github.com/SeregPie/lodash.permutations/blob/master/src/module.js
 * @param collection
 * @param n
 * @returns {[[]]|*[]}
 */
function permutations(collection, n) {
    let array = _.values(collection);
    if (array.length < n) {
        return [];
    }
    let recur = (array, n) => {
        if (--n < 0) {
            return [[]];
        }
        let permutations = [];
        array.forEach((value, index, array) => {
            array = array.slice();
            array.splice(index, 1);
            recur(array, n).forEach((permutation) => {
                permutation.unshift(value);
                permutations.push(permutation);
            });
        });
        return permutations;
    };
    return recur(array, n);
}

/**
 * 计算所有排列组合情况
 * @param collection
 * @returns {*[]}
 */
function permutationsAll(collection) {
    let array = _.values(collection);
    let returnArray = [];
    for (let index = 0; index < array.length; index++) {
        returnArray = returnArray.concat(permutations(collection, index + 1));
    }

    return returnArray;
}

function hideInitPageLoadingIcon() {
    const onPageLoad = () => {
        const fadeTarget = document.getElementById("loadingScreen");
        fadeTarget.style.transition = "0.8s";
        fadeTarget.style.display = "none";
    };

    // Check if the page has already loaded
    if (document.readyState === "complete") {
        onPageLoad();
    } else {
        window.addEventListener("load", onPageLoad);
        // Remove the event listener when component unmounts
        return () => window.removeEventListener("load", onPageLoad);
    }
}

function getHtmlInnerTextLength(html) {
    if (!html) {
        return 0;
    }

    let parser = new DOMParser();
    let doc = parser.parseFromString(html, "text/html");
    if (!doc) {
        return 0;
    }

    if (!doc.body) {
        return 0;
    }

    if (!doc.body.innerText) {
        return 0;
    }

    return doc.body.innerText.length;
}

function isHtmlContentEmpty(html) {
    if (!html) {
        return true;
    }

    let parser = new DOMParser();
    let doc = parser.parseFromString(html, "text/html");
    if (!doc) {
        return true;
    }

    if (!doc.body) {
        return true;
    }

    if (doc.body.getElementsByTagName("img").length > 0) {
        return false;
    }

    if (doc.body.getElementsByTagName("audio").length > 0) {
        return false;
    }

    if (doc.body.getElementsByTagName("video").length > 0) {
        return false;
    }

    if (doc.body.innerText && doc.body.innerText.length > 0) {
        return false;
    }

    return true;
}

function trimTailZero(num) {
    const s = String(num);
    const ss = s.split(".");
    if (ss[1]) {
        let count = 0;
        for (let i = ss[1].length - 1; i >= 0; --i) {
            if (ss[1][i] === "0") {
                count += 1;
            } else {
                break;
            }
        }

        if (count > 0) {
            if (count === ss[1].length) {
                return ss[0];
            }
            return ss[0] + "." + ss[1].substring(0, ss[1].length - count);
        }
    }
    return s;
}

/**
 * Map every node in a tree with a transform function
 * @param {object} node - The current tree node
 * @param {function} transform - Transform function to apply to each node
 * @param {object} [options] - Options for tree traversal
 * @param {string} [options.childrenKey='children'] - Key name for children nodes
 * @param {boolean} [options.keepNull=false] - Whether to keep null nodes in result
 * @param {boolean} [options.keepEmptyChildren=false] - Whether to keep empty children array
 * @param {object} [options.parent=null] - Parent node reference
 * @param {number} [options.level=0] - Current node level in tree
 * @param {number} [options.index=0] - Current node index in parent's children
 * @returns {object} The transformed tree
 */
function mapTree(
    node,
    transform,
    {
        childrenKey = 'children',
        keepNull = false,
        keepEmptyChildren = false,
        parent = null,
        level = 0,
        index = 0
    } = {}
) {
    if (!node) return keepNull ? null : undefined;

    // Transform current node with additional context
    const newNode = transform(node, {
        parent,
        level,
        index,
        isLeaf: !node[childrenKey] || node[childrenKey].length === 0
    });

    if (!newNode && !keepNull) return undefined;

    // Process children if they exist
    if (node[childrenKey] && node[childrenKey].length > 0) {
        const children = node[childrenKey]
            .map((child, i) =>
                mapTree(
                    child,
                    transform,
                    {
                        childrenKey,
                        keepNull,
                        keepEmptyChildren,
                        parent: node,
                        level: level + 1,
                        index: i
                    }
                )
            )
            .filter(child => child !== undefined);

        if (children.length > 0 || keepEmptyChildren) {
            newNode[childrenKey] = children;
        }
    }

    return newNode;
}

function getQueryParamValueByKey(key) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key);
}

const getInitI18nNamespaces = () => {
    //提前load所有components的ns,修复因为load ns造成的页面unmount问题
    //NOTE 要不然有可能会造成load某一个带i18n的组件的时候,刷新页面造成页面的reducer unregister造成各种问题
    //后期可能要研究一下 i18nNext的选项看看是不是配置造成的
    const componentNs = UIDs.components;
    const navbarNs = UIDs.layouts.navbars;
    const sidebarNs = UIDs.layouts.sidebar;
    const footerNs = UIDs.layouts.footers;
    const componentNSList = extractAllValuesIntoArray(componentNs);
    return [ UIDs.layouts.base, ...componentNSList, ...extractAllValuesIntoArray(navbarNs), ...extractAllValuesIntoArray(sidebarNs), ...extractAllValuesIntoArray(footerNs)];
};

export {
    convertSnakeCaseKeysToCamelCase,
    convertCamelCaseKeysToSnakeCase,
    getCurrentLocale,
    isCNCulture,
    decodeURL,
    subString,
    replaceURLToHttps,
    replaceHttpToFitHttpsInHtml,
    formatToHtmlString,
    convertCamelCaseKeysToUpperSnakeCase,
    getENNumSeqSuffix,
    generateUUID,
    isGuest,
    isLoggedIn,
    isNumeric,
    isNullOrEmpty,
    isNullOrUndefined,
    convertToFileServerPath,
    isCharacter,
    randomizeArray,
    createArrayWithNumbers,
    isChinese,
    isEnglish,
    getWords,
    getLocale,
    getCountries,
    getCountryName,
    getLastFileName,
    isPunctuation,
    numberWithCommas,
    containSpecialPunctuations,
    convertToLocalTime,
    convertToLocalString,
    convertToUtcTime,
    formatToUtcTime,
    addDays,
    getTimeZone,
    isNumberWithPunctuations,
    splitByDigit,
    displayPhone,
    buildFilePathInUnits,
    stripDeletedEmail,
    getLanguageCodes,
    existsSepcialContent,
    getImageWidthHeightWithPath,
    convertToAbsoluteUrl,
    getAvatarStr,
    createTwoDimensionArray,
    getNumberStr,
    buildPathSegments,
    isSubjective,
    removeSepcialUnicode,
    getWeekDays,
    getContainerSize,
    clearCache,
    isChineseCharacters,
    formatTimeDuration,
    extractAllValuesIntoArray,
    IsNoNeedCompareChar,
    replaceHtmlVirtualPath,
    permutations,
    permutationsAll,
    hideInitPageLoadingIcon,
    getHtmlInnerTextLength,
    isHtmlContentEmpty,
    trimTailZero,
    mapTree,
    getQueryParamValueByKey,
    formatString,
    getInitI18nNamespaces
};

export const getNameInitials = (fullName) => {
    const fInitial = Array.from(fullName.split(" ")[0])[0],
        lInitial = Array.from(fullName.split(" ")[1])[0];

    return `${fInitial}${lInitial}`;
};

export const colourNameToHex = (color) => {
    const colours = {
        aliceblue: "#f0f8ff",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        aquamarine: "#7fffd4",
        azure: "#f0ffff",
        beige: "#f5f5dc",
        bisque: "#ffe4c4",
        black: "#000000",
        blanchedalmond: "#ffebcd",
        blue: "#0000ff",
        blueviolet: "#8a2be2",
        brown: "#a52a2a",
        burlywood: "#deb887",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        cornflowerblue: "#6495ed",
        cornsilk: "#fff8dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkkhaki: "#bdb76b",
        darkmagenta: "#8b008b",
        darkolivegreen: "#556b2f",
        darkorange: "#ff8c00",
        darkorchid: "#9932cc",
        darkred: "#8b0000",
        darksalmon: "#e9967a",
        darkseagreen: "#8fbc8f",
        darkslateblue: "#483d8b",
        darkslategray: "#2f4f4f",
        darkturquoise: "#00ced1",
        darkviolet: "#9400d3",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        dimgray: "#696969",
        dodgerblue: "#1e90ff",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        forestgreen: "#228b22",
        fuchsia: "#ff00ff",
        gainsboro: "#dcdcdc",
        ghostwhite: "#f8f8ff",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gray: "#808080",
        green: "#008000",
        greenyellow: "#adff2f",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        "indianred ": "#cd5c5c",
        indigo: "#4b0082",
        ivory: "#fffff0",
        khaki: "#f0e68c",
        lavender: "#e6e6fa",
        lavenderblush: "#fff0f5",
        lawngreen: "#7cfc00",
        lemonchiffon: "#fffacd",
        lightblue: "#add8e6",
        lightcoral: "#f08080",
        lightcyan: "#e0ffff",
        lightgoldenrodyellow: "#fafad2",
        lightgrey: "#d3d3d3",
        lightgreen: "#90ee90",
        lightpink: "#ffb6c1",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        lightskyblue: "#87cefa",
        lightslategray: "#778899",
        lightsteelblue: "#b0c4de",
        lightyellow: "#ffffe0",
        lime: "#00ff00",
        limegreen: "#32cd32",
        linen: "#faf0e6",
        magenta: "#ff00ff",
        maroon: "#800000",
        mediumaquamarine: "#66cdaa",
        mediumblue: "#0000cd",
        mediumorchid: "#ba55d3",
        mediumpurple: "#9370d8",
        mediumseagreen: "#3cb371",
        mediumslateblue: "#7b68ee",
        mediumspringgreen: "#00fa9a",
        mediumturquoise: "#48d1cc",
        mediumvioletred: "#c71585",
        midnightblue: "#191970",
        mintcream: "#f5fffa",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        navajowhite: "#ffdead",
        navy: "#000080",
        oldlace: "#fdf5e6",
        olive: "#808000",
        olivedrab: "#6b8e23",
        orange: "#ffa500",
        orangered: "#ff4500",
        orchid: "#da70d6",
        palegoldenrod: "#eee8aa",
        palegreen: "#98fb98",
        paleturquoise: "#afeeee",
        palevioletred: "#d87093",
        papayawhip: "#ffefd5",
        peachpuff: "#ffdab9",
        peru: "#cd853f",
        pink: "#ffc0cb",
        plum: "#dda0dd",
        powderblue: "#b0e0e6",
        purple: "#800080",
        rebeccapurple: "#663399",
        red: "#ff0000",
        rosybrown: "#bc8f8f",
        royalblue: "#4169e1",
        saddlebrown: "#8b4513",
        salmon: "#fa8072",
        sandybrown: "#f4a460",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        sienna: "#a0522d",
        silver: "#c0c0c0",
        skyblue: "#87ceeb",
        slateblue: "#6a5acd",
        slategray: "#708090",
        snow: "#fffafa",
        springgreen: "#00ff7f",
        steelblue: "#4682b4",
        tan: "#d2b48c",
        teal: "#008080",
        thistle: "#d8bfd8",
        tomato: "#ff6347",
        turquoise: "#40e0d0",
        violet: "#ee82ee",
        wheat: "#f5deb3",
        white: "#ffffff",
        whitesmoke: "#f5f5f5",
        yellow: "#ffff00",
        yellowgreen: "#9acd32",
    };

    if (typeof colours[color.toLowerCase()] != "undefined") return colours[color.toLowerCase()];

    return "#000";
};

export const isColorLight = (color) => {
    const hex = color.replace("#", "");
    const c_r = parseInt(hex.substr(0, 2), 16);
    const c_g = parseInt(hex.substr(2, 2), 16);
    const c_b = parseInt(hex.substr(4, 2), 16);
    const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000;
    return brightness > 155;
};

export const goToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
};
